import { useMemo } from 'react';
import { useAccount } from '../../contexts/account/AccountContexts';

const useDisabledAccount = () => {
  const { accountResponse } = useAccount();

  const isDisabled = useMemo(() => {
    if (!accountResponse) {
      return null;
    }

    return ['DISABLED'].includes(accountResponse.accountStatus);
  }, [accountResponse]);

  return { isDisabled };
};

export default useDisabledAccount;
